// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mrp-popup-box {
  gap: 10px;
}

/* OrderIdValidationModal.css */

.return-modal-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 560px;
  background-color: #ffffff;
  color: #0f172a;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 32px 90px rgba(15, 23, 42, 0.24);
  overflow: visible;
  outline: none;
}

.return-modal-dark {
  background-color: #353a50;
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.12);
}

/* Header */
.return-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(180deg, rgba(248, 250, 252, 0.95) 0%, rgba(239, 246, 255, 0.95) 100%);
  border-radius: 28px 28px 0 0;
}

.return-modal-dark .return-modal-header {
  background: linear-gradient(180deg, rgba(53, 58, 80, 0.95) 0%, rgba(40, 45, 65, 0.95) 100%);
  border-bottom-color: rgba(255, 255, 255, 0.08);
}

.return-modal-title {
  font-size: 20px;
  font-weight: 600;
  color: #020617;
  margin: 0;
  letter-spacing: -0.01em;
}

.return-modal-dark .return-modal-title {
  color: #f8fafc;
}

.return-modal-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #64748b;
  border-radius: 6px;
  padding: 0;
  opacity: 0.7;
  transition: opacity 0.15s;
}

.return-modal-close:hover {
  opacity: 1;
}

/* Body */
.return-modal-body {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Form field */
.return-form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.return-form-label {
  font-size: 14px;
  font-weight: 500;
  color: #334155;
}

.return-modal-dark .return-form-label {
  color: #cbd5e1;
}

/* Two-column row for PIN + Order ID */
.return-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

@media (max-width: 480px) {
  .return-modal-container {
    max-width: 100%;
    border-radius: 0;
    top: 0;
    left: 0;
    transform: none;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .return-modal-header {
    border-radius: 0;
  }

  .return-modal-footer {
    border-radius: 0;
  }

  .return-form-row {
    grid-template-columns: 1fr;
  }
}

/* StyledSelect menu stays above the PIN/Order ID fields */
.return-modal-container .soft-select__menu {
  z-index: 10;
}

.return-select-wrapper .soft-select__control {
  /* background-color: rgba(248, 250, 252, 0.7) !important; */
  /* border-radius: 18px !important; */
  /* border: 1px solid #e2e8f0 !important; */
  height: 48px !important;
  box-sizing: border-box !important;
  transition: border-color 0.15s, background-color 0.15s;
}

.return-select-wrapper .soft-select__control--is-focused {
  border-color: #2a71ff !important;
  background-color: #ffffff !important;
  box-shadow: none !important;
}

.return-select-wrapper .soft-select__placeholder {
  color: #94a3b8 !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}

.return-select-wrapper .soft-select__single-value {
  color: #0f172a !important;
  font-weight: 500 !important;
  font-size: 14px !important;
}

/* Dark mode */
.return-modal-dark .return-select-wrapper .soft-select__control {
  background-color: rgba(255, 255, 255, 0.07) !important;
  border-color: rgba(255, 255, 255, 0.15) !important;
}

.return-modal-dark .return-select-wrapper .soft-select__control--is-focused {
  border-color: #2a71ff !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.return-modal-dark .return-select-wrapper .soft-select__single-value {
  color: #f1f5f9 !important;
}

.return-select-error .soft-select__control {
  border-color: #f43f5e !important;
}

/* Input */
.return-input {
  width: 100%;
  height: 48px;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  background-color: rgba(248, 250, 252, 0.7);
  padding: 0 16px;
  font-size: 14px;
  color: #0f172a;
  outline: none;
  transition:
    border-color 0.15s,
    background-color 0.15s;
  box-sizing: border-box;
}

.return-input::placeholder {
  color: #94a3b8;
  font-weight: 400;
}

.return-input:focus {
  border-color: #2a71ff;
  background-color: #ffffff;
}

.return-modal-dark .return-input {
  background-color: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.15);
  color: #f1f5f9;
}

.return-modal-dark .return-input:focus {
  border-color: #2a71ff;
  background-color: rgba(255, 255, 255, 0.1);
}

/* Error state */
.return-input-error {
  border-color: #f43f5e !important;
}

.return-field-error {
  font-size: 12px;
  font-weight: 500;
  color: #f43f5e;
  margin: 0;
}

/* PIN input wrapper */
.return-pin-wrapper {
  position: relative;
}

.return-pin-wrapper .return-input {
  padding-right: 44px;
}

.return-pin-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  cursor: pointer;
  color: #64748b;
  display: flex;
  align-items: center;
  padding: 4px;
}

.return-pin-toggle:hover {
  color: #334155;
}

.return-modal-dark .return-pin-toggle {
  color: #94a3b8;
}

.return-modal-dark .return-pin-toggle:hover {
  color: #e2e8f0;
}

/* Footer */
.return-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-top: 1px solid #f1f5f9;
  background-color: rgba(248, 250, 252, 0.6);
  border-radius: 0 0 28px 28px;
}

.return-modal-dark .return-modal-footer {
  border-top-color: rgba(255, 255, 255, 0.08);
  background-color: rgba(255, 255, 255, 0.04);
}

/* Buttons */
.return-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 44px;
  padding: 0 20px;
  border-radius: 18px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition:
    background-color 0.15s,
    box-shadow 0.15s,
    transform 0.1s;
  outline: none;
  border: 1px solid;
}

.return-btn:active {
  transform: scale(0.98);
  box-shadow: none !important;
}

.return-btn:disabled {
  opacity: 0.5;
  pointer-events: none;
}

.return-btn-cancel {
  background-color: #ffffff;
  border-color: #e2e8f0;
  color: #334155;
}

.return-btn-cancel:hover {
  background-color: #f8fafc;
}

.return-modal-dark .return-btn-cancel {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.2);
  color: #cbd5e1;
}

.return-modal-dark .return-btn-cancel:hover {
  background-color: rgba(255, 255, 255, 0.07);
}

.return-btn-proceed {
  background-color: #2a71ff;
  border-color: transparent;
  color: #ffffff;
  box-shadow: 0 14px 30px rgba(42, 113, 255, 0.24);
}

.return-btn-proceed:hover {
  background-color: #1f63ea;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/Returns/components/OrderIdValidationModal.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;;AAEA,+BAA+B;;AAE/B;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,0CAA0C;EAC1C,8CAA8C;EAC9C,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uCAAuC;AACzC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,iGAAiG;EACjG,4BAA4B;AAC9B;;AAEA;EACE,2FAA2F;EAC3F,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,MAAM;IACN,OAAO;IACP,eAAe;IACf,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,0DAA0D;AAC1D;EACE,WAAW;AACb;;AAEA;EACE,2DAA2D;EAC3D,oCAAoC;EACpC,0CAA0C;EAC1C,uBAAuB;EACvB,iCAAiC;EACjC,sDAAsD;AACxD;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,sDAAsD;EACtD,kDAAkD;AACpD;;AAEA;EACE,gCAAgC;EAChC,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,UAAU;AACV;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb;;0BAEwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;;kBAGgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".mrp-popup-box {\n  gap: 10px;\n}\n\n/* OrderIdValidationModal.css */\n\n.return-modal-container {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  max-width: 560px;\n  background-color: #ffffff;\n  color: #0f172a;\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  box-shadow: 0 32px 90px rgba(15, 23, 42, 0.24);\n  overflow: visible;\n  outline: none;\n}\n\n.return-modal-dark {\n  background-color: #353a50;\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.12);\n}\n\n/* Header */\n.return-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid #f1f5f9;\n  background: linear-gradient(180deg, rgba(248, 250, 252, 0.95) 0%, rgba(239, 246, 255, 0.95) 100%);\n  border-radius: 28px 28px 0 0;\n}\n\n.return-modal-dark .return-modal-header {\n  background: linear-gradient(180deg, rgba(53, 58, 80, 0.95) 0%, rgba(40, 45, 65, 0.95) 100%);\n  border-bottom-color: rgba(255, 255, 255, 0.08);\n}\n\n.return-modal-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #020617;\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n\n.return-modal-dark .return-modal-title {\n  color: #f8fafc;\n}\n\n.return-modal-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: #64748b;\n  border-radius: 6px;\n  padding: 0;\n  opacity: 0.7;\n  transition: opacity 0.15s;\n}\n\n.return-modal-close:hover {\n  opacity: 1;\n}\n\n/* Body */\n.return-modal-body {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Form field */\n.return-form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.return-form-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.return-modal-dark .return-form-label {\n  color: #cbd5e1;\n}\n\n/* Two-column row for PIN + Order ID */\n.return-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n@media (max-width: 480px) {\n  .return-modal-container {\n    max-width: 100%;\n    border-radius: 0;\n    top: 0;\n    left: 0;\n    transform: none;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n\n  .return-modal-header {\n    border-radius: 0;\n  }\n\n  .return-modal-footer {\n    border-radius: 0;\n  }\n\n  .return-form-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* StyledSelect menu stays above the PIN/Order ID fields */\n.return-modal-container .soft-select__menu {\n  z-index: 10;\n}\n\n.return-select-wrapper .soft-select__control {\n  /* background-color: rgba(248, 250, 252, 0.7) !important; */\n  /* border-radius: 18px !important; */\n  /* border: 1px solid #e2e8f0 !important; */\n  height: 48px !important;\n  box-sizing: border-box !important;\n  transition: border-color 0.15s, background-color 0.15s;\n}\n\n.return-select-wrapper .soft-select__control--is-focused {\n  border-color: #2a71ff !important;\n  background-color: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.return-select-wrapper .soft-select__placeholder {\n  color: #94a3b8 !important;\n  font-weight: 400 !important;\n  font-size: 14px !important;\n}\n\n.return-select-wrapper .soft-select__single-value {\n  color: #0f172a !important;\n  font-weight: 500 !important;\n  font-size: 14px !important;\n}\n\n/* Dark mode */\n.return-modal-dark .return-select-wrapper .soft-select__control {\n  background-color: rgba(255, 255, 255, 0.07) !important;\n  border-color: rgba(255, 255, 255, 0.15) !important;\n}\n\n.return-modal-dark .return-select-wrapper .soft-select__control--is-focused {\n  border-color: #2a71ff !important;\n  background-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.return-modal-dark .return-select-wrapper .soft-select__single-value {\n  color: #f1f5f9 !important;\n}\n\n.return-select-error .soft-select__control {\n  border-color: #f43f5e !important;\n}\n\n/* Input */\n.return-input {\n  width: 100%;\n  height: 48px;\n  border: 1px solid #e2e8f0;\n  border-radius: 18px;\n  background-color: rgba(248, 250, 252, 0.7);\n  padding: 0 16px;\n  font-size: 14px;\n  color: #0f172a;\n  outline: none;\n  transition:\n    border-color 0.15s,\n    background-color 0.15s;\n  box-sizing: border-box;\n}\n\n.return-input::placeholder {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n.return-input:focus {\n  border-color: #2a71ff;\n  background-color: #ffffff;\n}\n\n.return-modal-dark .return-input {\n  background-color: rgba(255, 255, 255, 0.07);\n  border-color: rgba(255, 255, 255, 0.15);\n  color: #f1f5f9;\n}\n\n.return-modal-dark .return-input:focus {\n  border-color: #2a71ff;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Error state */\n.return-input-error {\n  border-color: #f43f5e !important;\n}\n\n.return-field-error {\n  font-size: 12px;\n  font-weight: 500;\n  color: #f43f5e;\n  margin: 0;\n}\n\n/* PIN input wrapper */\n.return-pin-wrapper {\n  position: relative;\n}\n\n.return-pin-wrapper .return-input {\n  padding-right: 44px;\n}\n\n.return-pin-toggle {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  padding: 4px;\n}\n\n.return-pin-toggle:hover {\n  color: #334155;\n}\n\n.return-modal-dark .return-pin-toggle {\n  color: #94a3b8;\n}\n\n.return-modal-dark .return-pin-toggle:hover {\n  color: #e2e8f0;\n}\n\n/* Footer */\n.return-modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  border-top: 1px solid #f1f5f9;\n  background-color: rgba(248, 250, 252, 0.6);\n  border-radius: 0 0 28px 28px;\n}\n\n.return-modal-dark .return-modal-footer {\n  border-top-color: rgba(255, 255, 255, 0.08);\n  background-color: rgba(255, 255, 255, 0.04);\n}\n\n/* Buttons */\n.return-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 44px;\n  padding: 0 20px;\n  border-radius: 18px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition:\n    background-color 0.15s,\n    box-shadow 0.15s,\n    transform 0.1s;\n  outline: none;\n  border: 1px solid;\n}\n\n.return-btn:active {\n  transform: scale(0.98);\n  box-shadow: none !important;\n}\n\n.return-btn:disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.return-btn-cancel {\n  background-color: #ffffff;\n  border-color: #e2e8f0;\n  color: #334155;\n}\n\n.return-btn-cancel:hover {\n  background-color: #f8fafc;\n}\n\n.return-modal-dark .return-btn-cancel {\n  background-color: transparent;\n  border-color: rgba(255, 255, 255, 0.2);\n  color: #cbd5e1;\n}\n\n.return-modal-dark .return-btn-cancel:hover {\n  background-color: rgba(255, 255, 255, 0.07);\n}\n\n.return-btn-proceed {\n  background-color: #2a71ff;\n  border-color: transparent;\n  color: #ffffff;\n  box-shadow: 0 14px 30px rgba(42, 113, 255, 0.24);\n}\n\n.return-btn-proceed:hover {\n  background-color: #1f63ea;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
